import BloodDonationCard from '@src/components/Molecules/BloodDonation/BloodDonationCard';
import { IBloodHome } from '@src/interfaces/blood';
import React from 'react';
import styled from 'styled-components';
import NotFoundSvg from '@src/assets/imgs/blood-home/notfound.svg';
import { devices } from '@src/styles/theme';
type Props = {
  bloodHomes: IBloodHome[];
};

const INITIAL_RATING = 4.6;
const FIND_HOME_NAME_INDEX = 5;

const BloodDonationList = ({ bloodHomes }: Props) => {
  // console.log(bloodHomes);

  return (
    <Container
      is={bloodHomes?.length === 0}
      onClick={() => {
        sessionStorage.setItem('bloodHomes_scroll', String(window.scrollY));
      }}
    >
      {bloodHomes?.map((home) => {
        const title = home.name;
        const modifiedTitle = title.replace('집', `${'집'}\n`);
        const content = home.address.location;
        return (
          <BloodDonationCard
            key={home.uuid}
            title={modifiedTitle}
            contentAddress={content}
            rating={home.gpaAvg}
            reviewCount={home?.reviewCount}
            uuid={home?.uuid}
            kind={home?.kind}
          />
        );
      })}
      {bloodHomes?.length === 0 && (
        <NotFoundWrap>
          <NotFoundIcon />
          <NotFoundText>검색된 헌혈센터가 없습니다.</NotFoundText>
        </NotFoundWrap>
      )}
    </Container>
  );
};

const Container = styled.div<{ is: any }>`
  display: flex;
  gap: 3px;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: ${({ is }) => (is ? 'center' : 'flex-start')};

  @media ${devices.tablet} {
    padding: 10px;
  }
`;

const NotFoundIcon = styled(NotFoundSvg)`
  display: block;
  margin: 0 auto;
`;

const NotFoundText = styled.div`
  color: ${({ theme }) => theme.commonColor.gray005};
  text-align: center;
  font-family: 'Var';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.54px;
  margin-top: 30px;
`;

const NotFoundWrap = styled.div``;

export default BloodDonationList;
